import { BASE_URL } from '..';
const tokenData: any = localStorage.getItem('token');
const token = tokenData;
export const api_getPartyCaterings = async () => {
	const uri = `${BASE_URL}/catering/partyCatering`;

	try {
		const response = await fetch(uri, {
			method: 'GET',
			headers: {
				authorization: `Bearer ${token}`,
			},
		});

		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}

		const data = await response.json();
		return { isSuccess: true, data };
	} catch (error) {
		console.error('Fetch error:', error);
		return { isSuccess: false, message: error };
	}
};

export const api_getSubTypes = async () => {
	const uri = `${BASE_URL}/catering/partyCatering/sub`;

	try {
		const response = await fetch(uri, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				authorization: `Bearer ${token}`,
				// Add your authorization token logic here if needed
			},
		});

		if (!response.ok) {
			throw new Error(
				`Failed to fetch sub types (${response.status} ${response.statusText})`,
			);
		}

		const data = await response.json();

		return { isSuccess: true, data };
	} catch (error) {
		console.error('Fetch error:', error);
		throw error;
	}
};

export const api_getPartyCateringById = async (id: string) => {
	const uri = `${BASE_URL}/catering/partyCatering/${id}`;
	const response = await fetch(uri, {
		method: 'GET',
		headers: {
			authorization: `Bearer ${token}`,
			'Content-Type': 'application/json',
		},
	}).then((res) => res.json());
	return response;
};
export const api_createPartyCatering = async (payload: any) => {
	const uri = `${BASE_URL}/catering/partyCatering`;

	try {
		const response = await fetch(uri, {
			method: 'POST',
			headers: {
				authorization: `Bearer ${token}`,
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(payload),
		});

		if (!response.ok) {
			return {
				isSuccess: false,
				data: null,
				message: 'Failed to create the event type',
			};
		}

		const data = await response.json();
		return {
			isSuccess: true,
			data,
			message: 'Event type created successfully',
		};
	} catch (error) {
		return {
			isSuccess: false,
			data: null,
			message: error,
		};
	}
};
export const api_editPartyCatering = async (payload: any, partyCateringId: string) => {
	const uri = `${BASE_URL}/catering/partyCatering/${partyCateringId}`;
	console.log(partyCateringId);

	try {
		const response = await fetch(uri, {
			method: 'PUT',
			headers: {
				authorization: `Bearer ${token}`,
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(payload),
		});

		if (!response.ok) {
			return {
				isSuccess: false,
				data: null,
				message: 'Failed to edit the event type',
			};
		}

		const data = await response.json();
		return {
			isSuccess: true,
			data,
			message: 'Event type edited successfully',
		};
	} catch (error) {
		return {
			isSuccess: false,
			data: null,
			message: error,
		};
	}
};

export const api_deletePartyCatering = async (partyCateringId: string) => {
	const uri = `${BASE_URL}/catering/partyCatering/${partyCateringId}`;

	try {
		const response = await fetch(uri, {
			method: 'DELETE',
			headers: {
				authorization: `Bearer ${token}`,
			},
		});

		if (!response.ok) {
			return {
				isSuccess: false,
				data: null,
				message: 'Failed to delete the event type',
			};
		}

		const data = await response.json();
		return {
			isSuccess: true,
			data,
			message: 'Event type deleted successfully',
		};
	} catch (error) {
		return {
			isSuccess: false,
			data: null,
			message: error,
		};
	}
};
